import { render, staticRenderFns } from "./theme-card.vue?vue&type=template&id=10e15b42&scoped=true"
import script from "./theme-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./theme-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./theme-card.vue?vue&type=style&index=0&id=10e15b42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e15b42",
  null
  
)

export default component.exports